import React from 'react';

import { Link } from 'react-router';

import moment from 'moment';

function renderText({ child }) {
	return (
		<div style={{ textAlign: 'left' }}>{child}</div>
	);
}

function renderActions(_, { row, removeById }) {
	return (
		<div className='action-list'>
			<Link
				className='banners-edit-icon'
				to={`/blog/article-comments/${row.id}/editor`}
			/>
			<a
				className='remove-icon'
				onClick={() => {
					if (confirm('Delete article comment?')) {
						removeById(row.id);
					}
				}}
			/>
		</div>
	);
}

export default [
	[
		{
			index: 'id',
			header: {
				title: 'ID'
			},
			column: {}
		},
		{
			index: 'created_at',
			header: {
				title: 'created at'
			},
			column: {
				format: v => moment(v).format('DD.MM.YYYY HH:mm')
			}
		},
		{
			index: 'article',
			header: {
				title: 'article'
			},
			column: {
				format: v => v.title
			}
		},
		{
			index: 'affiliate',
			header: {
				title: 'affiliate'
			},
			column: {
				format: v => v.name
			}
		},
		{
			index: 'text',
			header: {
				title: 'text'
			},
			column: {
				render: renderText
			}
		},
		{
			index: 'actions',
			header: {
				title: 'actions'
			},
			column: {
				render: renderActions
			}
		}
	]
];


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/blog/article-comment/list/table-initial-data.js